import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from "@angular/router";
import { ToastController } from "@ionic/angular";
import { CookieService } from "ngx-cookie-service";
import { ProductType } from 'src/app/shared-lib/domains/product';
import { AppService } from 'src/app/shared/app.service';
import { CartService } from "../../shared/cart.service";

@Component({
  selector: 'app-home-summary-section',
  templateUrl: './home-summary-section.component.html',
  styleUrls: ['./home-summary-section.component.scss'],
  standalone: false
})
export class HomeSummarySectionComponent implements OnInit, OnChanges {
  @Input() printProduct;
  @Input() cartTotal = 0;
  @Input() isLoading = false;
  @Input() scrollHeight;
  @Input() isMobile;
  @ViewChild('groupsList') groupsList: ElementRef;

  selectedPriceTab: 'folder' | 'cart' = 'folder';

  constructor(
    public cartService: CartService,
    private toastController: ToastController,
    private router: Router,
    private cookieService: CookieService,
    protected appS: AppService
  ) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.printProduct && changes.printProduct.currentValue?.cartId !== changes.printProduct.previousValue?.cartId) {
      this.scrollToSelectedGroup();
    }
  }

  shouldAllowClick = () => {
    return !!this.printGroupItems().length && !this.isLoading;
  };

  async reload() {
    if (this.cartService.hasErrors()) {
      const toast = await this.toastController.create({
        message:
          "Algunos archivos tienen errores. Elimínalos antes de continuar.",
        color: "danger",
        position: 'bottom',
        cssClass: "fitWidthToast",
        duration: 2000,
      });
      await toast.present();
      return;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.cookieService.delete('bindingSelected');
    const navigationExtras: NavigationExtras = { state: { item: 'new' } };
    this.router.navigate(["/"], navigationExtras);
  }

  printGroupItems() {
    return this.cartService.cart.items.filter(
      (item) => item.product.type === ProductType.PRINT && !item.product.vendor
    );
  }

  private scrollToSelectedGroup() {
    setTimeout(() => {
      const selectedGroup = this.groupsList.nativeElement.querySelector('.selected');
      if (selectedGroup) {
        selectedGroup.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 200);
  }
}

